<template>
  <div class="lp-input-text-container">
    <div class="flex wrap">
      <div :key="'tag'+idx" v-for="(tag, idx) in tags" class="lp-tag-div">
        <div class="lp-tag">{{ tag }}<i class="lp-tag-delete unselect material-icons" @click="delTag(idx)">close</i></div>
        <div style="padding:8px 2px">,</div>
      </div>
      <div class="lp-tag-input-div">
        <input class="lp-input-text-input" @keyup="onKeyUp" type="text" :value="value"
               @input="e => value = e.target.value">
        <ul v-if="value!==''">
          <li :key="'tag'+idx" v-for="(tag,idx) in tagSearch"
              @click="clickLi(tag)"
              v-if="tag!=='' && tag.search(value)>-1">{{ tag }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      value: '',
      tags: [],
      tagSearch: ['']
    }
  },
  created() {
    this.tags = this.data;
  },
  watch: {
    data(n) {
      this.tags = n;
    }
  },
  methods: {
    onKeyUp(e) {
      if (e.key === 'Enter')
        this.onEnter();
      else if (e.key === 'Backspace')
        this.onDelete();
    },
    onEnter() {
      if (this.value !== '') {
        if (this.tags.length > 10) {
          this.toast('태그는 최대 10까지 등록 가능합니다.');
          this.value = '';
        }
        else {
          let hasTag = false;
          for (let i = 0; i < this.tags.length; i++) {
            if (this.tags[i] === this.value) {
              hasTag = true;
              break;
            }
          }

          if (!hasTag)
            this.tags.push(this.value);
          this.value = '';
        }
      }
    },
    clickLi(tag) {
      if (this.tags.length > 10) {
        this.toast('태그는 최대 10까지 등록 가능합니다.');
        this.value = '';
        return;
      }
      this.tags.push(tag);
      this.value = '';
    },
    onDelete() {
      if (this.value === '' && this.tags.length > 0) {
        removeIndex(this.tags, this.tags.length - 1);
      }
    },
    delTag(idx) {
      removeIndex(this.tags, idx);
    }
  },
  computed: {
    inputStyle() {
      let style = {};

      if (this.inputWidth !== undefined) {
        style.width = this.inputWidth;
      }
      if (this.block !== undefined) {
        style.display = this.block;
      }
      if (this.inputAlign !== undefined) {
        style.textAlign = this.inputAlign;
      }
      if (this.inputPadding !== undefined) {
        style.padding = this.inputPadding;
      }

      return style;
    },
    labelStyle() {
      let style = {};

      if (this.labelWidth !== undefined) {
        style.width = this.labelWidth;
      }
      if (this.block !== undefined) {
        style.display = this.block;
      }

      return style;
    }
  }
}
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'
  .lp-input-text-container
    padding 8px 10px
    padding-bottom 4px
    position relative
    border-radius 3px
    box-shadow inset 0 1px 2px rgba(10,10,10,0.1)
    border 1px solid #dbdbdb

  .lp-input-text-label
    margin-bottom 8px
    display block
    color #064160
    font-weight bold
    font-size 0.9rem

  .lp-input-text-input
    padding 6px 6px 5px 6px
    font-size 0.95rem
    color #555
    border 0
    display block

  .lp-tag-input-div
    flex 1
    position relative
    margin-bottom 6px

  ul
    position absolute
    top 36px
    border 1px solid #ddd
    border-radius 3px

  li
    font-size 0.9rem
    background-color #fff
    color #555
    padding 6px 12px

  li:hover
    background-color #ddd

  .lp-tag-div
    display flex
    margin 0 6px 6px 0
    height 28px

  .lp-tag
    display flex
    align-items center
    justify-content center
    color white
    text-align center
    font-size 0.9rem
    background-color $primary
    padding 4px 10px 4px 12px
    border-radius 20px
    height 28px

  input
    box-shadow none
    width 100%
  input:focus
    outline 0
    box-shadow none

  .lp-tag-delete
    font-size 12px
    margin-left 6px
</style>
